
import { defineComponent, ref } from 'vue'
import { useOrganizationModule } from '@/modules/organizations'
import { useFormModule } from '@/modules/_shared/forms'

export default defineComponent({
    name: 'sso-join-rules-form-field-organization',
    emits: ['update:modelValue'],
    props: {
        modelValue: {
            type: String
        }
    },
    async setup () {
        const { validations: { requiredRule } } = useFormModule()
        const { organizationsSimplified, getOrganizationsSimplified } = useOrganizationModule()

        await getOrganizationsSimplified()

        const organizationsOptions = organizationsSimplified.value.map((organization) => {
            return {
                label: organization.companyName,
                value: organization.id
            }
        })

        const filteredOptions = ref(organizationsOptions)

        const filterFn = (val: string, update: (arg: () => void) => void) => {
            update(() => {
                const needle = val.toLowerCase()
                filteredOptions.value = organizationsOptions.filter(v => v.label.toLowerCase().indexOf(needle) > -1)
            })
        }

        return {
            requiredRule,
            filterFn,
            filteredOptions
        }
    }
})
